import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { RotatedSortIcon } from "../../shared/components/TableFilter";
import { DocumentsData, DocumentType } from "../../../interfaces/document";
import moment from "moment";

const MovementLogTable = ({
  data,
  handeSortChange,
  handleOrderTypeChange,
  order,
  orderType,
}: {
  data: DocumentsData[];
  handeSortChange: (state: "ASC" | "DESC") => void;
  handleOrderTypeChange: (type: string) => void;
  order: "ASC" | "DESC";
  orderType: string;
}) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table
          sx={{
            table: {
              minWidth: 650,
            },
          }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("type");
                }}
              >
                Tipo
                {orderType === "type" && (
                  <IconButton>
                    <RotatedSortIcon rotation={order === "DESC" ? 0 : 180} />
                  </IconButton>
                )}
              </TableCell>
              <TableCell
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("createdAt");
                }}
              >
                Data
                {orderType === "createdAt" && (
                  <IconButton>
                    <RotatedSortIcon rotation={order === "DESC" ? 0 : 180} />
                  </IconButton>
                )}
              </TableCell>
              <TableCell
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("quantity");
                }}
              >
                Documento
              </TableCell>
              <TableCell
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("quantity");
                }}
              >
                Descrizione
              </TableCell>
              <TableCell
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("quantity");
                }}
              >
                UM
              </TableCell>
              <TableCell
                align="right"
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("quantity");
                }}
              >
                QTA
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row: DocumentsData) => (
              <TableRow key={row.id}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    color:
                      row.type === DocumentType.ACCEPTANCE
                        ? "success.main"
                        : "error.main",
                    fontWeight: "medium",
                  }}
                >
                  {row.type === DocumentType.ACCEPTANCE ? "CARICO" : "SCARICO"}
                </TableCell>

                <TableCell component="th" scope="row">
                  {moment(row.updatedAt).format("DD-MM-YYYY")}
                </TableCell>

                <TableCell component="th" scope="row">
                  {row.type === DocumentType.ACCEPTANCE
                    ? row.externalDocument
                    : row.ddtNumber}{" "}
                  DEL {moment(row.date).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell component="th" scope="row">
                  Ricambi Auto
                </TableCell>
                <TableCell component="th" scope="row">
                  PZ
                </TableCell>
                <TableCell component="th" scope="row" align="right">
                  {(row.products || []).reduce(
                    (sum, product) => sum + product.quantity,
                    0
                  ) * (row.type === DocumentType.ACCEPTANCE ? 1 : -1)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default MovementLogTable;
